namespace GeniuzPOS.InventoryReport {
    export namespace IcReportWhsEomService {
        export const baseUrl = 'InventoryReport/IcReportWhsEom';

        export declare function Create(request: Serenity.SaveRequest<IcReportWhsEomRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<IcReportWhsEomRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcReportWhsEomRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcReportWhsEomRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InventoryReport/IcReportWhsEom/Create",
            Update = "InventoryReport/IcReportWhsEom/Update",
            Delete = "InventoryReport/IcReportWhsEom/Delete",
            Retrieve = "InventoryReport/IcReportWhsEom/Retrieve",
            List = "InventoryReport/IcReportWhsEom/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcReportWhsEomService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
